// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"326":"f50fd1b1","696":"97e390a3","713":"058dbe70","917":"0796b0bb"}[chunkId] + ".css";
};